import React from 'react';

import { IconProps } from './types';

const CallAuditIcon: React.FC<IconProps> = props => {
  const { width = '24', height = '24', fillColor = 'var(--navi-color-gray-bg-primary)' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99945 17.9339C5.58132 17.9339 1.99971 14.3523 1.99971 9.93413C1.99971 5.51599 5.58132 1.93439 9.99945 1.93439C14.4176 1.93439 17.9992 5.51599 17.9992 9.93413C17.9992 14.3523 14.4176 17.9339 9.99945 17.9339Z"
        stroke={fillColor}
        strokeWidth="1.24477"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9997 21.9339L15.6566 15.5901"
        stroke={fillColor}
        strokeWidth="1.24477"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        transform="translate(6.5, 6.5)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.884715 0.26572L0.660057 0.490037C0.237553 0.912881 0 1.48606 0 2.08368C0 2.68129 0.237553 3.25447 0.660057 3.67698C1.35439 4.37131 2.19804 5.21496 2.89238 5.90963C3.31522 6.33214 3.8884 6.56935 4.48602 6.56935C5.08363 6.56935 5.65681 6.33214 6.07932 5.90963L6.30635 5.68226C6.47501 5.51394 6.56969 5.28555 6.56969 5.04732C6.56969 4.80909 6.47501 4.5807 6.30635 4.41203L5.71382 3.81951C5.54516 3.65085 5.31677 3.55617 5.07854 3.55617C4.84031 3.55617 4.61192 3.65085 4.44359 3.81951L4.18907 4.07369C4.16294 4.09982 4.12765 4.11441 4.09066 4.11441C4.05401 4.11441 4.01838 4.09982 3.99224 4.07369L2.49566 2.57711C2.46953 2.55098 2.45494 2.51568 2.45494 2.47869C2.45494 2.4417 2.46953 2.40641 2.49566 2.38028C2.62869 2.24759 2.75018 2.1261 2.75018 2.1261C2.91851 1.95744 3.01319 1.72905 3.01319 1.49081C3.01319 1.25258 2.91851 1.02419 2.75018 0.855869L2.15732 0.263005C1.989 0.094682 1.76061 0 1.52237 0C1.28414 0 1.05575 0.094682 0.88709 0.263005L0.884715 0.26572Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default CallAuditIcon;
